export enum CustomerDiscriminatorEnum {
  NATURAL_PERSON = 'NATURAL_PERSON',
  BUSINESS = 'BUSINESS',
}
